<div class="container-fluid d-flex flex-column h-100 overflow-auto" style="max-height: calc(100vh - 4rem); padding: 0 1rem 1.5rem 1rem;">
  <div class="flex-fill d-flex flex-column">
    <h2 class="upload-heading mb-2">Create a new workspace</h2>
    <div 
      class="upload-area flex-fill rounded-3 bg-white position-relative mb-3 mt-2"
      [class.disabled]="isGeneratingSchema"
      [class.drag-over]="isDragOver"
      (dragenter)="onDragEnter($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onFileDrop($event)"
    >
              <label class="d-block w-100 h-100 p-0 m-0" [style.cursor]="isGeneratingSchema ? 'not-allowed' : 'pointer'">
        <input
          type="file"
          class="d-none"
          [disabled]="isGeneratingSchema"
          (change)="onFileChange($event)"
          [accept]="valid_files"
          multiple
        />
        
        <div class="d-flex flex-column align-items-center justify-content-center h-100 p-4 text-center" style="min-height: 12rem;">
          <div class="mb-0" *ngIf="!uploadFileLoading">
            <lord-icon
              src="../../../assets/img/icons/cloud-upload.json"
              trigger="hover"
              class="upload-icon"
            ></lord-icon>
          </div>
          
          <div class="mb-0" *ngIf="uploadFileLoading">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <div class="text-center">
            <p class="fs-6 fw-medium mb-1">Drag and drop your files or click on the button to upload.</p>
            <p class="small text-muted mb-0">Maximum file size is 50MB</p>
          </div>
        </div>
      </label>
    </div>
    
    <!-- Data Pipeline Visualization -->
    <div class="pipeline-container">
      <div class="pipeline-stage">
        <div class="stage-icon">
          <img src="assets/img/icons/left_bulet.svg" alt="Stage 1" class="bullet-icon">
        </div>
        <h3 class="stage-title">Unstructured<br>Data</h3>
        <p class="stage-description">Raw, unorganized<br>information</p>
      </div>
      
      <div class="pipeline-stage">
        <div class="stage-icon">
          <img src="assets/img/icons/middle_bulet.svg" alt="Stage 2" class="bullet-icon">
        </div>
        <h3 class="stage-title">Data<br>Extraction</h3>
        <p class="stage-description">Identifying relevant<br>information</p>
      </div>
      
      <div class="pipeline-stage">
        <div class="stage-icon">
          <img src="assets/img/icons/middle_bulet.svg" alt="Stage 3" class="bullet-icon">
        </div>
        <h3 class="stage-title">Data<br>Transformation</h3>
        <p class="stage-description">Cleaning and formatting<br>data</p>
      </div>
      
      <div class="pipeline-stage">
        <div class="stage-icon">
          <img src="assets/img/icons/middle_bulet.svg" alt="Stage 4" class="bullet-icon">
        </div>
        <h3 class="stage-title">Data<br>Structuring</h3>
        <p class="stage-description">Organizing data into a<br>structured format</p>
      </div>
      
      <div class="pipeline-stage">
        <div class="stage-icon">
          <img src="assets/img/icons/right_bulet.svg" alt="Stage 5" class="bullet-icon">
        </div>
        <h3 class="stage-title">Structured<br>Data</h3>
        <p class="stage-description">Organized and easily<br>analyzed data</p>
      </div>
    </div>
  </div>
</div>

<!-- Help Menu Button -->
<div class="help-menu-container">
  <button 
    type="button" 
    class="help-button"
    (click)="toggleHelpMenu()"
    [class.active]="isHelpMenuOpen"
  >
    ?
  </button>
  
  <div class="help-menu" [class.show]="isHelpMenuOpen">
    <button type="button" class="help-menu-item" (click)="getHelp()" data-umami-event="Get Help">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.5"/>
        <path d="M6.5 6.5C6.5 5.5 7.5 4.5 8.5 4.5s2 1 2 2c0 1-1 1.5-2 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="8.5" cy="11" r="0.5" fill="currentColor"/>
      </svg>
      Get help
    </button>
    
    <button type="button" class="help-menu-item" (click)="talkToSales()" data-umami-event="Talk to Sales">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M14 6.5c0 2.5-2.5 4.5-5.5 4.5-.5 0-1-.1-1.5-.2L4 13l1.2-3c-.7-.8-1.2-1.8-1.2-2.5C4 4 6.5 2 9.5 2S14 4 14 6.5z" stroke="currentColor" stroke-width="1.5"/>
      </svg>
      Talk to sales
    </button>
  </div>
</div>

<app-onboarding-modal></app-onboarding-modal>

<!-- Schema Selection Modal -->
<app-schema-selection-modal
  [availableTemplates]="availableTemplates"
  [show]="showSchemaSelectionModal"
  (selectionMade)="onSchemaSelectionMade($event)"
  (cancelled)="onSchemaSelectionCancelled()"
></app-schema-selection-modal>
